import { render, staticRenderFns } from "./JobTemplates.vue?vue&type=template&id=5f845384&scoped=true&"
import script from "./JobTemplates.vue?vue&type=script&lang=js&"
export * from "./JobTemplates.vue?vue&type=script&lang=js&"
import style0 from "./JobTemplates.vue?vue&type=style&index=0&id=5f845384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f845384",
  null
  
)

export default component.exports